import React, { useEffect, useState } from 'react';
import Header from '~/components/header/Header';
import Block from '~/components/ui/block/Block';
import { styled } from "styled-components";
import Button from '~/components/ui/button/Button';
import Input from '~/components/ui/input/Input';
import Text from '~/components/ui/text/Text';
import apiService from '~/service/apiService';
import SubItem from '~/components/ui/subitem/Subitem';
import DropDown from '~/components/ui/dropdown/DropDown';

const LeftPart = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 10px;
  width: 379px;
  top: 22px;
  border-right: 1px solid #E0E0E0;
  
  .buttonGroup {
    margin-top: 12px;
    display: flex;
    justify-content: space-between;

    button {
      width: 48%;
    }
  }
  
  .formContainer {
      flex: 1;
  }
  
  .formContainer .desc {
      color: #000;
      font-family: Recoleta;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
  }
`;

const RightPart = styled.div`
  flex: 1;
  width: 100%;
  padding: 0px;
  margin: 10px;
  margin-left: 25px;
  top: 22px;
  
  .title {
    font-weight: 400 !important;
  }
  
  .conteinerForIframe {
  }
  
  .previewIframe {
      border: none;
      border-width: 0px;
      width: 100%;
      aspect-ratio: 13 / 7;
  }
  
  .iframeContainer {
      margin-top: 20px;
      margin-bottom: 20px;
      width: 100%;
      overflow: hidden;
  }
  
  .goToTheNextSequenceBtn {
    text-align: right;
    margin-top: 20px;
    button {
      padding-left: 40px;
      padding-right: 40px;
    }
  }
`;

const Select = styled.select`
  border: 0px solid;
  background: #F5F5F5;
  margin-right: 10px;
  padding: 14px;
  border-radius: 7px;
  color: #6F6F6F;
  max-width: 275px;
  height: 48px;
`;

const Wizard = ({activeStep, btnBackEvent, btnNextEvent, companyId, trainingId, jwt, showCourseNavigation}) => {

  const [refreshKey, setRefreshKey] = useState(Date.now());
  const [step, setStep] = useState(1);
  const [disabled, setDisabled] = useState(false);
  const [activeSequence, setActiveSequence] = useState(undefined);
  const [activeSequenceId, setActiveSequenceId] = useState(undefined);
  const [sequences, setSequences] = useState([]);
  const [trainingName, setTrainingName] = useState('');
  // const [training, setTraining] = useState('');
  const [dataWasSaved, setDataWasSaved] = useState(false);

  useEffect(() => {
    if (companyId && trainingId) {
      apiService.get(`/companies/${companyId}/trainings/${trainingId}`, jwt).then(data => {
        if (data && data.training) {
          setTrainingName(data.training.title);
          setSequences(data.training.sequences);

          const curSequence = data.training.sequences[step - 1];
          setActiveSequenceId(curSequence.id);
        }
      });
    }
  }, [companyId, trainingId, jwt]);

  useEffect(() => {
    if (activeSequenceId) {
      const _seq = sequences.find((seq) => seq.id == activeSequenceId);

      if (_seq) {
        setActiveSequence(_seq);
      }
    }
  }, [activeSequenceId]);

  const onChangeEvent = (id, value, type) => {
    setSequences(prevSequences =>
      prevSequences.map(sequence => {
        if (sequence.id === activeSequenceId) {
          const newSequence = {
            ...sequence,
            subitems: sequence.subitems.map(subitem => {
              if (subitem.id === id) {
                switch (type) {
                  case 'body':
                    return { ...subitem, body: { ...subitem.body, value } };
                  case 'title':
                    return { ...subitem, title: { ...subitem.title, value } };
                  case 'subtitle':
                    return { ...subitem, subtitle: { ...subitem.subtitle, value } };
                  case 'policyId':
                    return { ...subitem, selectedPolicy: value };
                  default:
                    return subitem;
                }
              }
              return subitem;
            })
          };

          setActiveSequence(newSequence);
          return newSequence;
        }
        return sequence;
      })
    );
  };

  const GoToThePrevSequence = () => {
    setDataWasSaved(true);
    const activeIndex = sequences.findIndex(item => item.id === activeSequenceId);

    if (activeIndex !== -1) {
      const prevItem = sequences[activeIndex - 1];

      if (prevItem) {
        setActiveSequenceId(prevItem.id);
        setStep(step - 1);
      } else {
        btnBackEvent();
      }
    } else {
      btnBackEvent();
    }

    setTimeout(() => setDataWasSaved(false), 4000);
  };

  const GoToTheNextSequence = () => {
    setDataWasSaved(true);
    const activeIndex = sequences.findIndex(item => item.id === activeSequenceId);

    if (activeIndex !== -1) {
      const nextItem = sequences[activeIndex + 1];

      if (nextItem) {
        setActiveSequenceId(nextItem.id);
        setStep(step + 1);
      } else {
        btnNextEvent();
      }
    } else {
      btnNextEvent();
    }

    setTimeout(() => setDataWasSaved(false), 4000);
  };

  const SaveSequence = (cb) => {
    setDisabled(true);

    setSequences(prevSequences => {
      const currentSequence = prevSequences.find(sequence => sequence.id === activeSequenceId);

      const dataForSending = {
        sequence: {
          id: currentSequence.id,
          subitemsAttributes: currentSequence.subitems.map(el => {
            if (el.policyId && el.selectedPolicy) {
              return { id: el.id, policyId: el.selectedPolicy }
            } else {
              const res = { id: el.id };

              if (el.body?.value) {
                res.body = el.body?.value;
              }

              if (el.title?.value) {
                res.title = el.title?.value;
              }

              return res;
            }
          })
        }
      };

      apiService.patch(`/companies/${companyId}/sequences/${activeSequenceId}`, dataForSending, jwt).then(() => {
        setTimeout(() => {
          setRefreshKey(Date.now());
          setDisabled(false);
        }, 100);

        if (cb && typeof cb === 'function') {
          cb();
        }
      });

      return prevSequences;
    });
  };

  const addSubItem = () => {
    setDisabled(true);

    const updatedSubitems = activeSequence.subitems.map(subitem => ({ ...subitem }));
    const templateForSubItem = { ...updatedSubitems[0] };
    delete templateForSubItem.id;
    updatedSubitems.push(templateForSubItem);

    const dataForSending = {
      sequence: { id: activeSequence.id, subitemsAttributes: updatedSubitems }
    };

    apiService.patch(`/companies/${companyId}/sequences/${activeSequenceId}`, dataForSending, jwt).then((data) => {
      if (data && data.sequence) {
        const updatedSequence = data.sequence;

        const combinedSubitems = [...activeSequence.subitems];
        updatedSequence.subitems.forEach(newSubitem => {
          const exists = combinedSubitems.some(subitem => subitem.id === newSubitem.id);
          if (!exists) {
            combinedSubitems.push(newSubitem);
          }
        });

        setActiveSequence(prevActiveSequence => ({ ...prevActiveSequence, ...updatedSequence, subitems: combinedSubitems }));

        setSequences(prevSequences => prevSequences.map(sequence => {
          if (sequence.id === updatedSequence.id) {
            const combinedSeqSubitems = [...sequence.subitems];
            updatedSequence.subitems.forEach(newSubitem => {
              const exists = combinedSeqSubitems.some(subitem => subitem.id === newSubitem.id);
              if (!exists) {
                combinedSeqSubitems.push(newSubitem);
              }
            });
            return { ...sequence, ...updatedSequence, subitems: combinedSeqSubitems };
          }
          return sequence;
        }));
      }
      setDisabled(false);
    });
  };

  const deleteSubItem = (id) => {
    setDisabled(true);

    const dataForSending = {
      sequence: {
        id: activeSequence.id,
        subitemsAttributes: activeSequence.subitems.map(el => {
          if (el.id == id) {
            return { id: el.id, _destroy: true };
          } else {
            return el;
          }
        })
      }
    };

    apiService.patch(`/companies/${companyId}/sequences/${activeSequenceId}`, dataForSending, jwt).then((data) => {
      if (data && data.sequence) {
        const updatedSequence = data.sequence;
        const updatedActiveSubitems = activeSequence.subitems.filter(subitem =>
          updatedSequence.subitems.some(newSubitem => newSubitem.id === subitem.id)
        );

        setActiveSequence(prevActiveSequence => ({ ...prevActiveSequence, ...updatedSequence, subitems: updatedActiveSubitems }));

        const updatedSequences = sequences.map(sequence => {
          if (sequence.id === updatedSequence.id) {
            const updatedSubitems = sequence.subitems.filter(subitem =>
              updatedSequence.subitems.some(newSubitem => newSubitem.id === subitem.id)
            );
            return { ...sequence, ...updatedSequence, subitems: updatedSubitems};
          }
          return sequence;
        });

        setSequences(updatedSequences);
      }

      setDisabled(false);
    });
  };

  const JumpToTheSlide = () => {
    const [jumpValue, setJumpValue] = useState(activeSequenceId);

    const onChange = (e) => {
      setJumpValue(e.target.value);
    };

    const Jump = () => {
      setDataWasSaved(true);
      const activeIndex = sequences.findIndex(item => item.id == jumpValue);

      if (activeIndex !== -1) {
        const nextItem = sequences[activeIndex];

        if (nextItem) {
          setActiveSequenceId(nextItem.id);
          setStep(activeIndex + 1);
          setJumpValue('');
        }

        SaveSequence(() => {
          setTimeout(() => setDataWasSaved(false), 4000);
        });
      }
    };

    return <div className='wz_dropdownForSlide'>
      <Select onChange={onChange} value={jumpValue} key={activeSequenceId}>
        {sequences.map((el, i) => {
          return <option key={`go_to__${el.id}`} value={el.id}>Slide {i + 1} - {el.title}</option>
        })}
      </Select>
      <Button title='Go' onClick={Jump} className='primaryBtn' disabled={disabled} />
    </div>
  };

  return (
    <div className='wizardWrapper'>
      <div className='header'>
        <Header dataWasSaved={dataWasSaved} trainingId={trainingId} companyId={companyId} activeStep={activeStep} title={trainingName} />
      </div>
      <div className='wz_container'>
        <Block>
          <LeftPart>
            <JumpToTheSlide />
            <hr />
            <h3 className='typography'>Slide {step}/{sequences?.length}</h3>
            {activeSequence && (
              <div className='formContainer'>
                <p className='desc'>{activeSequence.wizardQuestion}</p>
                {activeSequence.subitems.map((item, i) => {
                  return (
                    <SubItem key={`fr_${item.id}`} itemKey={i+1} length={activeSequence.subitems.length} duplicatable={item.duplicatable} disabledDeleteBtn={disabled} onDelete={() => deleteSubItem(item.id)}>
                      {item.title && <Input onChangeEvent={onChangeEvent} id={item.id} label={item.title.label} content={item.title.value} type='title' />}
                      {item.body && <Text onChangeEvent={onChangeEvent} id={item.id} label={item.body.label} content={item.body.value} type='body' />}
                      {item.policyId && item.policyId.type === 'dropdown' && <DropDown jwt={jwt} companyId={companyId} onChangeEvent={onChangeEvent} id={item.id} type='policyId' label={item.policyId.label} data={item.policyId.value} />}
                    </SubItem>
                  );
                })}
                {(activeSequence && activeSequence.subitems && activeSequence.subitems[0] && activeSequence.subitems[0].duplicatable) ? <Button title='Add' onClick={addSubItem} disabled={disabled} /> : false}
              </div>
            )}
            <div className='buttonGroup'>
              <Button title='Back' onClick={() => SaveSequence(GoToThePrevSequence)} disabled={disabled || step == 1} />
              <Button title='Save & Refresh' onClick={SaveSequence} className='primaryBtn' disabled={disabled} />
            </div>
          </LeftPart>
          <RightPart>
            <h1 className='title'>Preview</h1>
            <div className='iframeContainer'>
              <div className='conteinerForIframe'>
              {activeSequence && activeSequence.previewUrl && <iframe
                key={refreshKey}
                title='Training'
                className='previewIframe'
                src={`${activeSequence.previewUrl}&removeAllButtons=true&disableAutoPlay=true&dontPlayAudioAndVideo=true`} />}
              </div>
              <div className='goToTheNextSequenceBtn'>
                <Button title='Next' onClick={() => SaveSequence(GoToTheNextSequence)} className='primaryBtn' disabled={disabled} />
              </div>
            </div>
          </RightPart>
        </Block>
      </div>
    </div>
  );
};

export default Wizard;
